import React from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import { CopyAddress } from 'components/CopyAddress/CopyAddress';
import useNetwork from 'hooks/use-network';
import { LinkIcon16 } from 'modules/icons/LinkIcon16';
import { getAccountExplorerUrl, getTxnExplorerUrl } from 'utils/helper';

const shortenAddress = (address: string) => {
  return address.substring(0, 4) + '...' + address.substring(address.length - 6);
};

const useStyle = makeStyles<Theme>((theme) => ({
  root: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '20px',
    color: '#FAFAFA',
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px',
    },
  },
  link: {
    cursor: 'pointer',
    padding: '4px 4px 4px 0',
  },
  linkIcon: {
    marginLeft: '4px',
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      marginLeft: '2px',
    },

    '& svg': {
      color: '#ABABAB',
      width: 16,
      height: 17,
      '&:hover': {
        color: '#eeeeee',
      },
    },
  },
}));

type Props = {
  address: string;
  showLink?: boolean;
  isTxn?: boolean;
  displayAddress?: boolean;
};

// TODO_R: [FRS] move into /src/components/
// TODO_R: [RP] AddressWithCopyAndLinkIcons
export const WalletWithIcons = ({
  address,
  showLink = true,
  isTxn = false,
  displayAddress = true,
}: Props) => {
  const classes = useStyle();
  const [network] = useNetwork();

  return (
    <div className={classes.root}>
      {displayAddress && shortenAddress(address)}
      {displayAddress && <CopyAddress address={address} />}
      {showLink && (
        <a
          href={
            isTxn ? getTxnExplorerUrl(address, network) : getAccountExplorerUrl(address, network)
          }
          target="_blank"
          rel="noreferrer"
          className={classes.linkIcon}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <LinkIcon16 />
        </a>
      )}
    </div>
  );
};
